<script setup lang="ts">
import Modal from '../Modal.vue';
import useModal, { ModalTypes, modals } from '../../composables/useModal';
import { useLocale } from '../../composables/useLocale';

const { t } = useLocale();

const props = defineProps<{
  name: ModalTypes;
  isLoading: boolean;
}>();
const emit = defineEmits<{
  (event: 'delete'): void;
}>();

const { isOpen } = useModal(props.name);
</script>

<template>
  <Modal
    :name="modals.CONFIRM_DELETE_GROUP_CODE"
    :title="t('lcp.remove_group_code')"
    :is-open="isOpen"
    :loading="isLoading"
    :action="() => emit('delete')"
    action-color="error"
    :action-label="t('lcp.remove')"
  >
    <p>
      {{ t('lcp.remove_group_code_confirmation') }}
    </p>
  </Modal>
</template>
